///////COMPONENTS///////
import { put, select, takeLatest } from 'redux-saga/effects'
import ActionsTypes from '../../constants/ActionsTypes'
import { selectIdsUser } from '../selectors/user'
import { globalLoadingActionCreators, errorManagerActionCreators, recapStockActionsCreators, toastSuccessActionCreators } from '../actions'
import { POST_RECAP_STOCK as postRecap, PUT_RECAP_STOCK as putRecap, POST_RECAP_STOCK_FROM_REDIRECT as postRedirect } from '../../constants/Endpoint'
import { API_TOKEN } from '../../config/AxiosConfig'

// region POST REQUEST ...

const postRecapStock = function* ({ payload }) {
	const idsUser = yield select(selectIdsUser)
	const bodyMsg = payload.filters
	// bodyMsg['userKioskScope'] = {
	// 	kiosksInLocalScope: idsUser.kiosksPool
	// }

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(idsUser.jwt).post(postRecap(payload.queryParams), bodyMsg)

		yield put(recapStockActionsCreators.postRecapStockSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))
		yield put(recapStockActionsCreators.postRecapStockFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

// endregion

//region PUT REQUEST ...

const putRecapStock = function* ({ payload }) {
	const idsUser = yield select(selectIdsUser)

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(idsUser.jwt).put(putRecap(), payload.data)

		yield put(recapStockActionsCreators.putRecapStockSuccess(payload.data))
		yield put(globalLoadingActionCreators.endLoading())

		yield put(toastSuccessActionCreators.hydrateToast('toast__stockManagement__admin__update'))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))
		yield put(recapStockActionsCreators.putRecapStockFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const postRecapStockFromRedirect = function* ({ payload }) {
	const idsUser = yield select(selectIdsUser)
	const bodyMsg = payload.filters

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(idsUser.jwt).post(postRedirect(payload.queryParams), bodyMsg)

		yield put(recapStockActionsCreators.postRecapStockFromRedirectSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))
		yield put(recapStockActionsCreators.postRecapStockFromRedirectFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

//endregion

const sagas = function* () {
	yield takeLatest(ActionsTypes.POST_RECAP_STOCK_REQUEST, postRecapStock)
	yield takeLatest(ActionsTypes.PUT_RECAP_STOCK_REQUEST, putRecapStock)
	yield takeLatest(ActionsTypes.POST_RECAP_STOCK_FROM_REDIRECT, postRecapStockFromRedirect)
}

export default sagas
